import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import HelmetWrapper from 'components/HelmetWrapper';
import { useParams } from 'react-router-dom';
import ShareableLinkFiles from './components/ShareableLinkFiles';
import ShareableLinkViewers from './components/ShareableLinkViewers';
import { useLockScrollOnReroute } from 'hooks/useLockScrollOnReroute';

import './ShareableLink.styles.scss';

type ShareableLinkProps = {
  className?: string;
};

const ShareableLink: React.FC<ShareableLinkProps> = (props) => {
  const { className } = props;

  const classes = classNames('shareable-link', 'page', className);

  const { t } = useTranslation();

  const { shareableLinkId } = useParams<{ shareableLinkId: string }>();

  useLockScrollOnReroute();

  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('secureShare')} - ${t('sharingInsights')}`} />
      <h2>{t('sharingInsights')}</h2>

      <div className={classNames('files-wrapper', 'white-panel')}>
        <p>{t('filesLog')}</p>

        <ShareableLinkFiles shareableLinkId={shareableLinkId} />
      </div>

      <div className={classNames('viewers-wrapper', 'white-panel')}>
        <p>{t('activityLog')}</p>
        <ShareableLinkViewers shareableLinkId={shareableLinkId} />
      </div>
    </div>
  );
};

export default ShareableLink;
